import * as columnFormatters from "../../../components/column-formatters";

import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";

export const columns = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  {
    dataField: "uniqueIGN",
    text: "Company ID",
    sort: true,
    show: true,
  },
  {
    dataField: "user.gamerjiName",
    text: "Company Name",
    sort: true,
    show: true,
  },
  {
    dataField: "country",
    text: "Country",
    sort: true,
    show: true,
  },
  {
    dataField: "user.phone",
    text: "Total Ads",
    sort: true,
    show: true,
  },
  {
    dataField: "user.wallet.coinAmount",
    text: "Active Ads",
    sort: true,
    show: true,
  },
  {
    dataField: "rank",
    text: "Revenue",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
];

export const columns_contest_users = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  {
    dataField: "AdsID",
    text: "Ads ID",
    sort: true,
    show: true,
  },
  {
    dataField: "Companyname",
    text: "Company name",
    sort: true,
    show: true,
  },
  {
    dataField: "Countries",
    text: "Countries",
    sort: true,
    show: true,
    format: {
      formatter: (cell) => cell.map((countries) => countries.name).join(", "),
    },
  },
  {
    dataField: "BrandName",
    text: "Brand Name",
    sort: true,
    show: true,
  },
  {
    dataField: "BrandImage.default",
    text: "Brand Image",
    sort: true,
    show: true,
    format: {
      type: "image",
      formatter: columnFormatters.ImageURLFormatter,
    },
  },
  {
    dataField: "AdsLink",
    text: "Ads Link",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
  {
    dataField: "AdsTitle1",
    text: "Ads Title 1",
    sort: true,
    show: true,
    format: {
      // type: 'textbox',
    },
  },
  {
    dataField: "description",
    text: "Ads Title 2",
    sort: true,
    show: true,
  },
  {
    dataField: "DealType",
    text: "Deal Type",
    sort: true,
    show: true,
  },
  {
    dataField: "PerdayCapping",
    text: "Per day Capping",
    sort: true,
    show: true,
  },
  {
    dataField: "AdsEarningCurrency",
    text: "Ads Earning Currency",
    sort: true,
    show: true,
    format: {
      formatter: (cell, row) => cell?.name ?? "N/A",
    },
  },
  {
    dataField: "AdsEarningAmount",
    text: "Ads Earning Amount",
    sort: true,
    show: true,
  },
  {
    dataField: "TotalEarning",
    text: "Total Earning",
    sort: true,
    show: true,
    format: {
      formatter: (cell) => {
        const totalEarning = cell && cell[0] ? cell[0].total : "N/A";
        return totalEarning;
      },
    },
  },
  {
    dataField: "Impression",
    text: "Impression",
    sort: true,
    show: true,
    format: {
      // formatter: columnFormatters.timeFormatCol,
    },
  },
  {
    dataField: "Views",
    text: "Views",
    sort: true,
    show: true,
  },
  {
    dataField: "Clicks",
    text: "Clicks",
    sort: true,
    show: true,
  },
];

export const columns_ads_log = [
  {
    dataField: "noIndex",
    text: "#",
    sort: true,
    show: true,
    format: {
      style: {
        width: "40px",
        minWidth: "40px",
      },
    },
  },
  {
    dataField: "user_id",
    text: "User ID",
    sort: true,
    show: true,
  },
  {
    dataField: "company_id",
    text: "Company ID",
    sort: true,
    show: true,
  },
  {
    dataField: "brand_name",
    text: "Brand name",
    sort: true,
    show: true,
  },
  {
    dataField: "country",
    text: "Country",
    sort: true,
    show: true,
  },
  {
    dataField: "ads_id",
    text: "Ads ID",
    sort: true,
    show: true,
  },
  {
    dataField: "date",
    text: "Date",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.dateFormatCol,
    },
  },
  {
    dataField: "date",
    text: "Time",
    sort: true,
    show: true,
    format: {
      formatter: columnFormatters.timeFormatCol,
    },
  },
  {
    dataField: "log_type",
    text: "Log Type",
    sort: true,
    show: true,
  },
];
